import { JSX } from 'react';

const LandingPage = (): JSX.Element => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#111',
        color: '#FFD700',
        fontSize: '4rem',
        fontWeight: 'bold',
      }}
    >
      🎰 {process.env.REACT_APP_WEBSITENAME}
    </div>
  );
};

export default LandingPage;
